import { render, staticRenderFns } from "./platformFormB.vue?vue&type=template&id=3f8dc5ba&scoped=true&"
import script from "./platformFormB.vue?vue&type=script&lang=js&"
export * from "./platformFormB.vue?vue&type=script&lang=js&"
import style0 from "./platformFormB.vue?vue&type=style&index=0&id=3f8dc5ba&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8dc5ba",
  null
  
)

export default component.exports